export default __webpack_public_path__ + "static/media/wey-logo.b0800a2c.png";